import { render, staticRenderFns } from "./AddDevis.vue?vue&type=template&id=fb523fc6&"
import script from "./AddDevis.vue?vue&type=script&lang=js&"
export * from "./AddDevis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports